import { render, staticRenderFns } from "./studentInfo-studentList.vue?vue&type=template&id=5b0f13e1"
import script from "./studentInfo-studentList.vue?vue&type=script&lang=js"
export * from "./studentInfo-studentList.vue?vue&type=script&lang=js"
import style0 from "./studentInfo-studentList.vue?vue&type=style&index=0&id=5b0f13e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports